import { LitElement, css } from 'lit';
import { customElement } from 'lit/decorators.js';

import { getLogger } from './globalFunctions';
const log = getLogger('AppIndex');

import './pages/app-home';
import './components/shared/aichatinterface';
import './components/login';
import './components/signup';
import './components/header';
import './components/viewer';
import './components/token';
import './components/form';
import './styles/global.css';
import { sessionStore, rehydrateSession, setSession, clearSession } from './stores/sessionStore.js';
import { schemaStore, rehydrateSchema, addSchema} from './stores/schemaStore.js';

import { router } from './router';
//import { session } from './session';

@customElement('app-index')
export class AppIndex extends LitElement {
  static styles = css`
  `;

  router;

  firstUpdated() {
  }

  connectedCallback() {
    super.connectedCallback();
    this.init();
  }

  async init() {
    await rehydrateSession(); // Rehydrate the chat store when the component is created
    await rehydrateSchema(); // Rehydrate the schema store when the component is created
    this.router = await router();
    this.router.addEventListener('route-changed', async () => {
      if ("startViewTransition" in document) {
        (document as any).startViewTransition(() => this.requestUpdate());
      } else {
        this.requestUpdate();
        await this.updateComplete;
      }
    });
    const session = sessionStore.get();
    //log('callback session', session);
    if (!session.isLoggedIn && localStorage.getItem('x-jwt-token')) {
      localStorage.removeItem('x-jwt-token');
      localStorage.removeItem('x-account');
      clearSession();
      window.location.href = '/';
    }
  }

  render() {
    // router config can be round in src/router.ts
    //log('render', this.router);
    if (this.router) {
      return this.router.render();
    }
  }
}
